import {
	APP_LOGIN,
	FORGETPASSWORD,
	LOGIN,
	PADDLE_CHECKOUT,
	PRICING,
	RESET_PASSWORD,
	SIGNUP,
	VERIFY_OTP,
} from '@constants/internal-route.constant';
import { useAuth } from '@context/Auth';
import AuthLayout from '@layout/AuthLayout';
import PublicLayout from '@layout/PublicLayout';
import { setWindowTitle } from '@services/helper/common.helper';
import AppLogin from 'pages/AppLogin';
import ForgetPassword from 'pages/ForgetPassword';
import Home from 'pages/Home';
import ResetPassword from 'pages/ResetPassword';
import VerifyOtp from 'pages/VerifyOtp';
import PaddleCheckout from '@modules/billing/PaddleCheckout';
import Pricing from 'pages/pricing';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { PrivateRoutes } from 'routes/PrivateRoutes';
import Login from './pages/Login';
import SignUp from './pages/Signup';

// const AuthRoute = ({ children }) => {
//   const { isAuthenticated } = useAuth();
//   if (isAuthenticated) return <Navigate to={HOME} />;
//   return children;
// };

const App = () => {
	setWindowTitle();
	const { pathname } = window.location;
	const { isAuthenticated } = useAuth();

	return (
		<BrowserRouter>
			<Routes>
				<Route element={<AuthLayout />}>
					<Route
						path={APP_LOGIN}
						element={<AppLogin />}
					/>
					{!isAuthenticated && (
						<>
							<Route
								path={LOGIN}
								element={<Login />}
							/>
							<Route
								path={SIGNUP}
								element={<SignUp />}
							/>
							<Route
								path={FORGETPASSWORD}
								element={<ForgetPassword />}
							/>
							<Route
								path={VERIFY_OTP}
								element={<VerifyOtp />}
							/>
							<Route
								path={RESET_PASSWORD}
								element={<ResetPassword />}
							/>
							<Route
								path='*'
								element={
									<Navigate
										to={LOGIN}
										state={{ from: pathname }}
									/>
								}
							/>
						</>
					)}
				</Route>
				{isAuthenticated && (
					<Route
						path='*'
						element={<PrivateRoutes />}
					/>
				)}
				{/*
				  Outside every layout AND outside the isAuthenticated branches on purpose: a Paddle
				  recovery link arrives from an email with no session, and the logged-out branch's
				  catch-all would otherwise bounce it to /login and lose the ?_ptxn reference.
				  React Router ranks a static path above '*', so this wins either way.
				*/}
				<Route
					path={PADDLE_CHECKOUT}
					element={<PaddleCheckout />}
				/>
				{/* Signed in, "/" and /pricing open inside the console (PrivateRoutes). */}
				{!isAuthenticated && (
					<Route element={<PublicLayout />}>
						<Route
							index
							element={<Home />}
						/>
						<Route
							path={PRICING}
							element={<Pricing />}
						/>
					</Route>
				)}
			</Routes>
		</BrowserRouter>
	);
};

export default App;
